// 基于 875eb71880e2bd5e0c12655ae31c277262976522 修复：
// 429后自动强制刷新（后台无感知），解决 429后 add/change/update 全是429必须手动F5的问题
(function () {
  'use strict';
  if (window.__SALPIFY_CUSTOM_SCRIPT_LOADED__) return;
  window.__SALPIFY_CUSTOM_SCRIPT_LOADED__ = true;

  const COOLDOWN_429_MS = 5000;
  let globalCooldownUntil = 0;
  let bgReloadTimer = null;
  let cachedCartResponse = null;
  let cachedCartJson = null;
  const cachedSectionsResponse = new Map();

  function getUrlString(url) { if(typeof url==='string') return url; if(url instanceof Request) return url.url; return ''; }
  function isInCooldown(){ return Date.now() < globalCooldownUntil; }

  // 429后自动刷新页面 - 这是解决"必须手动刷新"的唯一可靠办法，Cloudflare challenge必须靠新导航拿新 cf_clearance
  function scheduleAutoReload(){
    if(bgReloadTimer) return;
    // 避免死循环：30s内只自动刷新一次
    try{
      const last = Number(sessionStorage.getItem('salepify_auto_reload_at')||0);
      if(Date.now() - last < 30000) return;
      sessionStorage.setItem('salepify_auto_reload_at', String(Date.now()));
    }catch(e){}
    bgReloadTimer = setTimeout(()=>{ bgReloadTimer=null; try{ window.location.reload(); }catch(e){} }, COOLDOWN_429_MS + 300);
  }

  function applyCooldown(){
    globalCooldownUntil = Date.now() + COOLDOWN_429_MS;
    console.warn('[Salepify] Cart 429, cooldown 5s -> auto reload scheduled');
    scheduleAutoReload();
  }

  function classify(url,method){
    const u=getUrlString(url); const m=(method||'GET').toUpperCase();
    if(/\/cart\.js(\?|$)/.test(u) && m==='GET') return 'get-cart-js';
    if(/\/cart\/change\.js/.test(u) && m==='POST') return 'post-change';
    if((/\/cart\/update\.js/.test(u)||/\/cart\/update(\?|$)/.test(u)) && m==='POST') return 'post-update';
    if(/\/cart\/add\.js/.test(u) && m==='POST') return 'post-add';
    if(/\/cart(\?|$)/.test(u) && m==='GET' && (u.includes('sections=')||u.includes('section_id='))) return 'get-sections';
    return null;
  }
  function emptyCart(){ return { token:'', note:null, attributes:{}, total_price:0, total_weight:0, items:[], item_count:0, requires_shipping:false, currency:'USD', items_subtotal_price:0, cart_level_discount_applications:[] }; }
  function jsonRes(body,status){ return new Response(JSON.stringify(body), { status:status||200, headers:{'Content-Type':'application/json'}}); }
  function getCachedCart(){ if(cachedCartResponse){ try{ return cachedCartResponse.clone(); }catch(e){} } return jsonRes(cachedCartJson||emptyCart()); }

  // cart:refresh debounce 450ms - 合并 RestockRocket/BOGOS 的连续刷新
  (function(){
    const DEBOUNCE=450; let timer=null, pending=null;
    const target=document.documentElement, orig=target.dispatchEvent.bind(target);
    target.dispatchEvent=function(e){
      if(!(e instanceof CustomEvent)||e.type!=='cart:refresh') return orig(e);
      pending=e; clearTimeout(timer);
      timer=setTimeout(()=>{ const ev=pending; pending=null; timer=null; if(ev) orig(ev); },DEBOUNCE);
      return true;
    };
  })();

  // fetch 节流 + 冷却期短路（避免429风暴继续打Cloudflare）
  (function(){
    const _fetch=window.fetch.bind(window);
    const lastTime={}, inFlight={};
    const THROTTLE={'get-cart-js':2000,'post-change':600,'post-update':2000,'post-add':800,'get-sections':1500};

    window.fetch=function(url,options){
      const method=(options?.method||'GET').toUpperCase();
      const type=classify(url,method);
      if(!type) return _fetch.apply(this,arguments);

      // 冷却期内：不再发真实网络请求，直接用缓存/空响应，避免越点越429
      if(isInCooldown()){
        if(type==='get-cart-js') return Promise.resolve(getCachedCart());
        if(type==='get-sections'){
          const k=getUrlString(url); const c=cachedSectionsResponse.get(k);
          if(c){ try{ return Promise.resolve(c.clone()); }catch(e){} }
          return Promise.resolve(jsonRes({}));
        }
        if(type.startsWith('post-')) return Promise.resolve(jsonRes({ description:'Too many requests. Page will refresh shortly.' },429));
      }

      const now=Date.now(), throttle=THROTTLE[type]||0;

      if(type==='get-cart-js'){
        if(now-(lastTime[type]||0)<throttle) return Promise.resolve(getCachedCart());
        if(inFlight[type]) return inFlight[type].then(()=>getCachedCart(),()=>getCachedCart());
        lastTime[type]=now;
        inFlight[type]=_fetch.apply(this,arguments).then(res=>{
          if(res.ok){ cachedCartResponse=res.clone(); res.clone().json().then(j=>cachedCartJson=j).catch(()=>{}); }
          else if(res.status===429) applyCooldown();
          return res;
        }).finally(()=>inFlight[type]=null);
        return inFlight[type].then(res=> !res.ok||res.status===429 ? getCachedCart():res );
      }

      if(type==='get-sections'){
        const k=getUrlString(url);
        if(now-(lastTime[k]||0)<throttle){ const c=cachedSectionsResponse.get(k); if(c){ try{ return Promise.resolve(c.clone()); }catch(e){} } }
        if(inFlight[k]) return inFlight[k].then(r=>r.clone());
        lastTime[k]=now;
        inFlight[k]=_fetch.apply(this,arguments).then(res=>{
          if(res.ok) cachedSectionsResponse.set(k,res.clone());
          else if(res.status===429) applyCooldown();
          return res;
        }).finally(()=>inFlight[k]=null);
        return inFlight[k];
      }

      if(type.startsWith('post-')){
        if(inFlight[type] && now-(lastTime[type]||0)<throttle) return inFlight[type];
        lastTime[type]=now;
        inFlight[type]=_fetch.apply(this,arguments).then(res=>{
          if(res.status===429) applyCooldown();
          else if(res.ok){ cachedCartResponse=null; cachedCartJson=null; cachedSectionsResponse.clear(); }
          return res;
        }).finally(()=>inFlight[type]=null);
        return inFlight[type];
      }
      return _fetch.apply(this,arguments);
    };
  })();
})();
